module.exports = __webpack_public_path__ + "img/bg1.5f27c02c.jpg";